<template>
  <div
    v-if="toolbarMode != ToolbarMode.None && dropdown"
    class="absolute top-[168px] z-10 h-[calc(100dvh-168px)] w-full overflow-hidden 2xs:top-[175px] 2xs:h-[calc(100vh-175px)] xs:hidden"
  >
    <div class="h-[calc(100dvh-168px)] overflow-y-auto bg-white py-4 shadow-md">
      <ui-dropdown-search
        :placeholder="dropdown.placeholder"
        padding="px-6"
        :initial-search="undefined"
        @update:search="(value) => (search = value)"
      />
      <ui-dropdown-items :filters="dropdown.sections" :dropdown-type="toolbarMode" padding="px-6" :search="search" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ToolbarMode, useToolbarStore } from '@/features';
import { ref } from 'vue';

const { toolbarMode, dropdown } = storeToRefs(useToolbarStore());

const search = ref<string>('');
</script>
